import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "raceFlagFilled"
const RaceFlagFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 9.75H8.25V6H12z" />
          <path
            fillRule="evenodd"
            d="M19.5.75C20.328.75 21 1.422 21 2.25V12.75C21 13.578 20.328 14.25 19.5 14.25H4.5V22.5H3V2.25C3 1.422 3.672.75 4.5.75zM8.25 6H4.5V9.75H8.25V12.75H12V9.75H15.75V12.75H19.5V9.75H15.75V6H19.5V2.25H15.75V6H12V2.25H8.25z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default RaceFlagFilledIcon
